import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./index.scss";
import CategoryService from "../../../services/category";
import ProductService from "../../../services/product";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import Select from "react-select";

const categoryService = new CategoryService();
const productService = new ProductService();

// Helper function to parse array data from backend
const parseArrayData = (data) => {
  console.log("parseArrayData input:", data, "Type:", typeof data);
  
  if (Array.isArray(data)) {
    // Check if it's already a proper array with string items (not JSON strings)
    const isProperArray = data.every(item => typeof item === 'string' && !item.startsWith('['));
    
    if (isProperArray) {
      console.log("Data is already a proper array, returning as-is");
      return data.filter((item) => item && item.trim());
    }
    
    // Handle case where array contains a single JSON string
    if (data.length === 1 && typeof data[0] === 'string') {
      const firstItem = data[0];
      console.log("Single string item:", firstItem);
      
      // Check if it's a JSON array string
      if (firstItem.startsWith('[') && firstItem.endsWith(']')) {
        try {
          const parsed = JSON.parse(firstItem);
          console.log("Parsed JSON:", parsed);
          if (Array.isArray(parsed)) {
            return parsed.filter((item) => item && item.trim());
          }
        } catch (e) {
          console.log("JSON parse failed, treating as comma-separated");
          // If parsing fails, treat as comma-separated string
          return firstItem
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
        }
      } else {
        // Regular string, split by comma
        return firstItem
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item.length > 0);
      }
    }
    // Handle normal array with multiple items
    return data.filter((item) => item && item.trim());
  } else if (typeof data === 'string') {
    try {
      // Try to parse if it's a JSON string
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed)) {
        return parsed.filter((item) => item && item.trim());
      }
    } catch (e) {
      // If parsing fails, treat as comma-separated string
      return data
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
    }
  }
  return [];
};

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [productData, setProductData] = useState({
    title: "",
    slug: "",
    reference: "",
    description: "",
    categoryId: "",
    quantite: 0,
    prixHorsTax: 0,
    tva: 0,
    ttc: 0,
    isOnPromo: false,
    pourcentagePromo: 0,
    ttcFinal: 0,
    promoStartDate: "",
    promoEndDate: "",
    status: true,
    produitType: "",
    stockEnStock: true,
    stockRupture: false,
    stockAttenteLivraison: false,
    bienfaits: [],
    utilisation: [],
    activeClee: [{ titre: "", description: "", image: null }],
    produitsAssocies: [],
  });

  // Separate state for raw input values (for editing)
  const [rawInputs, setRawInputs] = useState({
    bienfaits: "",
    utilisation: ""
  });

  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [imagePrincipale, setImagePrincipale] = useState([]);
  const [listeImage, setListeImage] = useState([]);
  const [existingimagePrincipale, setExistingimagePrincipale] = useState([]);
  const [existingListeImage, setExistingListeImage] = useState([]);
  const [existingActiveClee, setExistingActiveClee] = useState([]);
  const [keptExistingImages, setKeptExistingImages] = useState([]);
  // Function to remove image by index from both arrays
  const removeImageByIndex = (indexToRemove) => {
    console.log("Removing image at index:", indexToRemove);

    // Remove from existing images
    const newExisting = existingimagePrincipale.filter(
      (_, idx) => idx !== indexToRemove
    );
    setExistingimagePrincipale(newExisting);

    // Remove from kept images (should be the same as existing)
    const newKept = keptExistingImages.filter(
      (_, idx) => idx !== indexToRemove
    );
    setKeptExistingImages(newKept);

    console.log("New existing images:", newExisting);
    console.log("New kept images:", newKept);
  };
  const [isLoading, setIsLoading] = useState(true);

  // Gestion des champs texte / checkbox / radio
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === "checkbox" ? checked : value;

    if (name === "prixHorsTax" || name === "tva") {
      const prixHorsTax =
        name === "prixHorsTax"
          ? parseFloat(newValue) || 0
          : parseFloat(productData.prixHorsTax) || 0;
      const tva =
        name === "tva"
          ? parseFloat(newValue) || 0
          : parseFloat(productData.tva) || 0;
      const ttc = prixHorsTax + (prixHorsTax * tva) / 100;
      const ttcFinal = productData.isOnPromo
        ? ttc - (ttc * (productData.pourcentagePromo || 0)) / 100
        : ttc;

      setProductData({
        ...productData,
        [name]: newValue,
        ttc: parseFloat(ttc.toFixed(3)),
        ttcFinal: parseFloat(ttcFinal.toFixed(3)),
      });
    } else if (name === "pourcentagePromo") {
      const promo = parseFloat(newValue) || 0;
      const ttcFinal = productData.ttc - (productData.ttc * promo) / 100;
      setProductData({
        ...productData,
        pourcentagePromo: promo,
        ttcFinal: parseFloat(ttcFinal.toFixed(3)),
      });
    } else if (name === "isOnPromo") {
      const isOnPromo = checked;
      const ttcFinal = isOnPromo
        ? productData.ttc -
          (productData.ttc * (productData.pourcentagePromo || 0)) / 100
        : productData.ttc;
      setProductData({
        ...productData,
        isOnPromo,
        ttcFinal: parseFloat(ttcFinal.toFixed(3)),
      });
    } else if (name === "produitsAssocies") {
      const selectedOptions = Array.from(e.target.selectedOptions).map(
        (opt) => opt.value
      );
      setProductData({
        ...productData,
        produitsAssocies: selectedOptions,
      });
    } else {
      setProductData({
        ...productData,
        [name]: newValue,
      });
    }
  };

  // Charger catégories et produits
  const loadData = async () => {
    setIsLoading(true);
    try {
      const resCategories = await categoryService.getAllCategories();
      setCategories(resCategories?.data);

      const resProducts = await productService.getAllProducts();
      setProducts(resProducts?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
    setIsLoading(false);
  };

  // Charger le produit
  const loadProduct = async () => {
    try {
      const res = await productService.getProductById(id);
      const product = res.data;

      setProductData({
        title: product.title || "",
        slug: product.slug || "",
        reference: product.reference || "",
        description: product.description || "",
        categoryId: product.categoryId || "",
        quantite: product.quantite || 0,
        prixHorsTax: product.prixHorsTax || 0,
        tva: product.tva || 0,
        ttc: product.ttc || 0,
        isOnPromo: product.isOnPromo || false,
        pourcentagePromo: product.pourcentagePromo || 0,
        ttcFinal: product.ttcFinal || product.ttc || 0,
        promoStartDate: product.promoStartDate || "",
        promoEndDate: product.promoEndDate || "",
        status: product.status ?? true,
        produitType: product.isBestSeller
          ? "bestSeller"
          : product.isBientotDispo
          ? "bientotDispo"
          : product.isNouveaux
          ? "nouveaux"
          : "",
        stockEnStock: product.onStock ?? true,
        stockRupture: product.stockRupture || false,
        stockAttenteLivraison: product.stockAttenteLivraison || false,
        bienfaits: parseArrayData(product.bienfaits),
        utilisation: parseArrayData(product.utilisation),
        activeClee: product.activeClee?.length
          ? product.activeClee.map((ac) => ({
              titre: ac.titre,
              description: ac.description,
              image: null,
            }))
          : [{ titre: "", description: "", image: null }],
        produitsAssocies: product.produitsAssocies || [],
      });

      // Store existing images for display - parse imagePrincipale like other array fields
      const existingImages = parseArrayData(product.imagePrincipale) || [];
      console.log("Loading product - existing images:", existingImages);
      setExistingimagePrincipale(existingImages);
      setExistingListeImage(parseArrayData(product.listeImage) || []);
      setExistingActiveClee(product.activeClee || []);

      // Initialize kept images as all existing images
      setKeptExistingImages(existingImages);
      console.log("Initialized kept images:", existingImages);

      // Debug: Log the arrays to see what we're getting
      console.log("Raw product bienfaits:", product.bienfaits);
      console.log("Raw product utilisation:", product.utilisation);
      console.log("Processed bienfaits:", productData.bienfaits);
      console.log("Processed utilisation:", productData.utilisation);
      console.log("Bienfaits input value will be:", productData.bienfaits.join(", "));
    } catch (err) {
      showErrorToaster("Erreur lors du chargement du produit");
    }
  };

  useEffect(() => {
    loadData();
    loadProduct();
  }, [id]);

  // Update raw inputs when productData changes
  useEffect(() => {
    console.log("useEffect triggered - productData.bienfaits:", productData.bienfaits);
    console.log("useEffect triggered - productData.utilisation:", productData.utilisation);
    
    if (productData.bienfaits && productData.bienfaits.length > 0) {
      const bienfaitsString = productData.bienfaits.join(", ");
      console.log("Setting rawInputs.bienfaits to:", bienfaitsString);
      setRawInputs(prev => ({
        ...prev,
        bienfaits: bienfaitsString
      }));
    }
    if (productData.utilisation && productData.utilisation.length > 0) {
      const utilisationString = productData.utilisation.join(", ");
      console.log("Setting rawInputs.utilisation to:", utilisationString);
      setRawInputs(prev => ({
        ...prev,
        utilisation: utilisationString
      }));
    }
  }, [productData.bienfaits, productData.utilisation]);

  // Bienfaits et utilisation - now just store raw input
  const handleBienfaitsChange = (e) => {
    const value = e.target.value;
    setRawInputs({ ...rawInputs, bienfaits: value });
  };

  const handleUtilisationChange = (e) => {
    const value = e.target.value;
    setRawInputs({ ...rawInputs, utilisation: value });
  };

  // Active Clee
  const handleActiveCleeChange = (index, e) => {
    const { name, value, files } = e.target;
    const newActiveClee = [...productData.activeClee];
    if (name === "image") {
      newActiveClee[index][name] = files[0];
    } else {
      newActiveClee[index][name] = value;
    }
    setProductData({ ...productData, activeClee: newActiveClee });
  };
  const addActiveClee = () => {
    setProductData({
      ...productData,
      activeClee: [
        ...productData.activeClee,
        { titre: "", description: "", image: null },
      ],
    });
  };
  const removeActiveClee = (index) => {
    const newActiveClee = productData.activeClee.filter((_, i) => i !== index);
    setProductData({ ...productData, activeClee: newActiveClee });
  };

  // Envoi formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Process raw inputs into arrays before submission
    const processedBienfaits = rawInputs.bienfaits
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
    
    const processedUtilisation = rawInputs.utilisation
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
    
    const formData = new FormData();

    Object.keys(productData).forEach((key) => {
      if (key === "bienfaits") {
        formData.append(key, JSON.stringify(processedBienfaits));
      } else if (key === "utilisation") {
        formData.append(key, JSON.stringify(processedUtilisation));
      } else if (key === "produitsAssocies") {
        formData.append(key, JSON.stringify(productData[key]));
      } else if (key !== "activeClee" && key !== "produitType") {
        formData.append(key, productData[key]);
      }
    });

    formData.set("isBestSeller", productData.produitType === "bestSeller");
    formData.set("isBientotDispo", productData.produitType === "bientotDispo");
    formData.set("isNouveaux", productData.produitType === "nouveaux");

    formData.set("onStock", !!productData.stockEnStock);
    formData.set("stockRupture", !!productData.stockRupture);
    formData.set("stockAttenteLivraison", !!productData.stockAttenteLivraison);

    if (productData.isOnPromo) {
      formData.set("promoStartDate", productData.promoStartDate);
      formData.set("promoEndDate", productData.promoEndDate);
    }

    // Handle imagePrincipale - send kept existing images and new files separately
    console.log("ImagePrincipale state:", imagePrincipale);
    console.log("Kept existing images:", keptExistingImages);
    console.log("ImagePrincipale length:", imagePrincipale.length);

    // Send new files if any
    if (imagePrincipale.length > 0) {
      imagePrincipale.forEach((file, index) => {
        console.log(
          `Appending new file ${index}:`,
          file.name,
          file.type,
          file.size
        );
        formData.append("imagesPrincipales", file);
      });
    }

    // Always send the kept existing images array as individual items
    keptExistingImages.forEach((imageName, index) => {
      formData.append("imagePrincipale", imageName);
    });
    console.log("Sending kept existing images:", keptExistingImages);
    console.log("Sending new files:", imagePrincipale.length);

    // Handle listeImage
    listeImage.forEach((file) => formData.append("listeImage", file));

    productData.activeClee.forEach((item, index) => {
      formData.append(`activeClee[${index}][titre]`, item.titre);
      formData.append(`activeClee[${index}][description]`, item.description);
      if (item.image instanceof File)
        formData.append(`activeClee[${index}][image]`, item.image);
    });

    try {
      console.log("Updating product with ID:", id);
      console.log("FormData contents:", formData);
      const response = await productService.updateProduct(id, formData);
      console.log("Update response:", response);
      showSuccessToaster("Produit mis à jour avec succès !");
      navigate("/products");
    } catch (err) {
      console.error("Update error:", err);
      console.error("Error response:", err.response);
      showErrorToaster(
        `Erreur lors de la mise à jour du produit: ${
          err.response?.data?.message || err.message
        }`
      );
    }
  };

  if (isLoading) return <p>Chargement...</p>;

  return (
    <Form className="add-product-form" onSubmit={handleSubmit}>
      {/* Détails généraux */}
      <div className="card-details">
        <h5>Détails généraux du produit</h5>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Group controlId="title">
              <Form.Label>Titre</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={productData.title}
                onChange={handleChange}
                required
                placeholder="Saisir le nom du produit"
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group controlId="slug">
              <Form.Label>Lien permanent</Form.Label>
              <Form.Control
                type="text"
                name="slug"
                value={productData.slug}
                onChange={handleChange}
                required
                placeholder="https://api.almasecret.msit-demo.fr/produit"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Champ Référence */}
        <Form.Group controlId="reference" className="mb-3">
          <Form.Label>Référence produit</Form.Label>
          <Form.Control
            type="text"
            name="reference"
            value={productData.reference}
            onChange={handleChange}
            placeholder="Référence interne du produit"
          />
        </Form.Group>

        <Form.Group controlId="description" className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="description"
            value={productData.description}
            onChange={handleChange}
            placeholder="Saisir la description du produit"
          />
        </Form.Group>

        <Form.Group controlId="categoryId" className="mb-3">
          <Form.Label>Catégorie</Form.Label>
          <Form.Select
            name="categoryId"
            value={productData.categoryId}
            onChange={handleChange}
            required>
            <option value="">-- Sélectionner une catégorie --</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat._id}>
                {cat.title}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* Images principales existantes */}
        {existingimagePrincipale.length > 0 && (
          <Form.Group controlId="existingimagePrincipale" className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Form.Label className="mb-0">
                Images principales existantes
              </Form.Label>
              <Button
                variant="outline-warning"
                size="sm"
                onClick={() => {
                  console.log("Clearing all images");
                  setExistingimagePrincipale([]);
                  setKeptExistingImages([]);
                  // Also clear new images if any
                  setImagePrincipale([]);
                }}>
                Effacer toutes les images
              </Button>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {existingimagePrincipale.map((img, i) => (
                <div key={`${img}-${i}`} className="position-relative">
                  <img
                    src={`https://api.almasecret.msit-demo.fr/products/${id}/image/${i}`}
                    alt="Principale"
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                  />
                  <div
                    className="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => removeImageByIndex(i)}
                    title={`Supprimer l'image ${i + 1}: ${img}`}>
                    ×
                  </div>
                  <div
                    className="position-absolute bottom-0 start-0 bg-dark text-white px-1"
                    style={{ fontSize: "10px" }}>
                    {i + 1}
                  </div>
                </div>
              ))}
            </div>
          </Form.Group>
        )}

        <Form.Group controlId="imagePrincipale" className="mb-3">
          <Form.Label>
            Nouvelles images principales (Maximum 2 images)
          </Form.Label>
          <Form.Control
            type="file"
            multiple
            accept="image/*"
            onChange={(e) => {
              const files = Array.from(e.target.files);
              if (files.length > 2) {
                showErrorToaster(
                  "Vous ne pouvez sélectionner que 2 images maximum pour les images principales."
                );
                setImagePrincipale(files.slice(0, 2));
              } else {
                setImagePrincipale(files);
              }
            }}
          />
          <Form.Text className="text-muted">
            Vous pouvez sélectionner jusqu'à 2 images. Les nouvelles images
            remplaceront les existantes.
            {imagePrincipale.length > 0 && (
              <span className="text-primary">
                {" "}
                ({imagePrincipale.length}/2 images sélectionnées)
              </span>
            )}
          </Form.Text>
        </Form.Group>

        {/* Aperçu des nouvelles images */}
        {imagePrincipale.length > 0 && (
          <Form.Group controlId="previewimagePrincipale" className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Form.Label className="mb-0">
                Aperçu des nouvelles images
              </Form.Label>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => setImagePrincipale([])}>
                Effacer les nouvelles images
              </Button>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {imagePrincipale.map((file, i) => (
                <div key={i} className="position-relative">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`Preview ${i + 1}`}
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                  />
                  <div
                    className="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const newImages = imagePrincipale.filter(
                        (_, idx) => idx !== i
                      );
                      setImagePrincipale(newImages);
                    }}>
                    ×
                  </div>
                </div>
              ))}
            </div>
          </Form.Group>
        )}
      </div>

      {/* Détails tarifaires */}
      <div className="card-details mt-4">
        <h5>Détails tarifaires</h5>
        <Row>
          <Col md={4}>
            <Form.Group controlId="prixHorsTax" className="mb-3">
              <Form.Label>Prix HT</Form.Label>
              <Form.Control
                type="number"
                name="prixHorsTax"
                value={productData.prixHorsTax}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="tva" className="mb-3">
              <Form.Label>TVA (%)</Form.Label>
              <Form.Control
                type="number"
                name="tva"
                value={productData.tva}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group controlId="ttc" className="mb-3">
              <Form.Label>TTC</Form.Label>
              <Form.Control
                type="number"
                name="ttc"
                value={productData.ttc}
                disabled
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group controlId="isOnPromo" className="mb-3">
          <Form.Check
            type="checkbox"
            label="En promotion"
            name="isOnPromo"
            checked={productData.isOnPromo}
            onChange={handleChange}
          />
        </Form.Group>

        {productData.isOnPromo && (
          <>
            <Form.Group controlId="pourcentagePromo" className="mb-3">
              <Form.Label>Pourcentage promo</Form.Label>
              <Form.Control
                type="number"
                name="pourcentagePromo"
                value={productData.pourcentagePromo}
                onChange={handleChange}
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group controlId="promoStartDate" className="mb-3">
                  <Form.Label>Date début promo</Form.Label>
                  <Form.Control
                    type="date"
                    name="promoStartDate"
                    value={productData.promoStartDate}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="promoEndDate" className="mb-3">
                  <Form.Label>Date fin promo</Form.Label>
                  <Form.Control
                    type="date"
                    name="promoEndDate"
                    value={productData.promoEndDate}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="ttcFinal" className="mb-3">
              <Form.Label>Prix final TTC</Form.Label>
              <Form.Control
                type="number"
                name="ttcFinal"
                value={productData.ttcFinal}
                disabled
              />
            </Form.Group>
          </>
        )}
      </div>

      {/* État des stocks */}
      <div className="card-details mt-4">
        <h5>État des stocks</h5>
        {/* Quantité et status */}
        <Row>
          <Col md={12}>
            <Form.Group controlId="quantite" className="mb-3">
              <Form.Label>Quantité</Form.Label>
              <Form.Control
                type="number"
                name="quantite"
                value={productData.quantite}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Stock (radio booléens) */}
        <Form.Group controlId="stockStatus" className="mb-3">
          <Form.Label>Statut du stock</Form.Label>
          <div>
            <Form.Check
              type="radio"
              label="En stock"
              name="stockStatus"
              checked={productData.stockEnStock}
              onChange={() =>
                setProductData({
                  ...productData,
                  stockEnStock: true,
                  stockRupture: false,
                  stockAttenteLivraison: false,
                })
              }
              inline
            />
            <Form.Check
              type="radio"
              label="Rupture de stock"
              name="stockStatus"
              checked={productData.stockRupture}
              onChange={() =>
                setProductData({
                  ...productData,
                  stockEnStock: false,
                  stockRupture: true,
                  stockAttenteLivraison: false,
                })
              }
              inline
            />
            <Form.Check
              type="radio"
              label="En attente de livraison"
              name="stockStatus"
              checked={productData.stockAttenteLivraison}
              onChange={() =>
                setProductData({
                  ...productData,
                  stockEnStock: false,
                  stockRupture: false,
                  stockAttenteLivraison: true,
                })
              }
              inline
            />
          </div>
        </Form.Group>
      </div>

      {/* Informations complémentaires */}
      <div className="card-details mt-4">
        <h5>Informations complémentaires</h5>
        {/* Type de produit (radio) */}
        <Col md={6}>
          <Form.Group controlId="status" className="mb-3">
            <Form.Check
              type="checkbox"
              label="Produit publié"
              name="status"
              checked={productData.status}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Form.Group controlId="produitType" className="mb-3">
          <Form.Label>Type de produit</Form.Label>
          <div>
            <Form.Check
              type="radio"
              label="Best Seller"
              name="produitType"
              value="bestSeller"
              checked={productData.produitType === "bestSeller"}
              onChange={handleChange}
              inline
            />
            <Form.Check
              type="radio"
              label="Bientôt disponible"
              name="produitType"
              value="bientotDispo"
              checked={productData.produitType === "bientotDispo"}
              onChange={handleChange}
              inline
            />
            <Form.Check
              type="radio"
              label="Nouveau produit"
              name="produitType"
              value="nouveaux"
              checked={productData.produitType === "nouveaux"}
              onChange={handleChange}
              inline
            />
          </div>
        </Form.Group>

        {/* Bienfaits */}
        <Form.Group controlId="bienfaits" className="mb-3">
          <Form.Label>Bienfaits (séparés par une virgule)</Form.Label>
          <Form.Control
            type="text"
            value={rawInputs.bienfaits}
            onChange={handleBienfaitsChange}
            placeholder="Bienfait 1, Bienfait 2, Bienfait 3"
          />
        </Form.Group>

        {/* Utilisation */}
        <Form.Group controlId="utilisation" className="mb-3">
          <Form.Label>Utilisation (séparées par une virgule)</Form.Label>
          <Form.Control
            type="text"
            value={rawInputs.utilisation}
            onChange={handleUtilisationChange}
            placeholder="Utilisation 1, Utilisation 2, Utilisation 3"
          />
        </Form.Group>

        {/* Liste images */}
        <Form.Group controlId="listeImage" className="mb-3">
          <Form.Label>Liste d'images</Form.Label>
          <Form.Control
            type="file"
            multiple
            onChange={(e) => setListeImage([...e.target.files])}
          />
        </Form.Group>

        {/* Active Clé */}
        <h5 className="mt-3">Active Clé</h5>
        {productData.activeClee.map((item, index) => (
          <div key={index} className="active-cle-item mb-2">
            <Row>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Titre"
                  name="titre"
                  value={item.titre}
                  onChange={(e) => handleActiveCleeChange(index, e)}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="text"
                  placeholder="Description"
                  name="description"
                  value={item.description}
                  onChange={(e) => handleActiveCleeChange(index, e)}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="file"
                  name="image"
                  onChange={(e) => handleActiveCleeChange(index, e)}
                />
              </Col>
            </Row>
            <Button
              variant="danger"
              size="sm"
              onClick={() => removeActiveClee(index)}
              className="mt-2">
              Supprimer
            </Button>
          </div>
        ))}
        <Button variant="outline-primary" onClick={addActiveClee}>
          Ajouter une active clé
        </Button>
      </div>

      {/* Produits associés */}
      <div className="card-details mt-4">
        <Form.Group controlId="produitsAssocies" className="mb-3">
          <Form.Label>Produits associés</Form.Label>
          <Select
            isMulti
            name="produitsAssocies"
            options={products.map((prod) => ({
              value: prod._id,
              label: prod.title,
            }))}
            className="basic-multi-select"
            classNamePrefix="select"
            value={products
              .map((prod) => ({
                value: prod._id,
                label: prod.title,
              }))
              .filter((opt) =>
                productData.produitsAssocies.includes(opt.value)
              )}
            onChange={(selectedOptions) => {
              setProductData({
                ...productData,
                produitsAssocies: selectedOptions.map((opt) => opt.value),
              });
            }}
          />
        </Form.Group>{" "}
      </div>

      {/* Images de liste existantes */}
      {existingListeImage.length > 0 && (
        <div className="card-details mt-4">
          <h5>Images de liste existantes</h5>
          <div className="d-flex flex-wrap gap-2">
            {existingListeImage.map((img, i) => (
              <img
                key={i}
                src={`https://api.almasecret.msit-demo.fr/products/${id}/listeImage/${i}`}
                alt="Liste"
                style={{
                  width: 100,
                  height: 100,
                  objectFit: "cover",
                  borderRadius: "4px",
                }}
              />
            ))}
          </div>
        </div>
      )}

      {/* Active Clee existantes */}
      {existingActiveClee.length > 0 && (
        <div className="card-details mt-4">
          <h5>Actives clés existantes</h5>
          <div className="d-flex flex-wrap gap-2">
            {existingActiveClee.map((ac, index) => (
              <div key={index} className="text-center">
                <img
                  src={`https://api.almasecret.msit-demo.fr/products/${id}/activeClee/${index}`}
                  alt="Active Clee"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                    borderRadius: "4px",
                  }}
                />
                <div className="mt-2">
                  <strong>{ac.titre}</strong>
                  <p className="small">{ac.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button variant="secondary" onClick={() => navigate("/product")}>
          Annuler
        </Button>
        <Button variant="primary" type="submit">
          Mettre à jour le produit
        </Button>
      </div>
    </Form>
  );
};

export default EditProduct;
